import { makeAsyncCall } from 'src/utils';
import { BACKEND_URL } from 'src/constants';

const healthCheck = () =>
  makeAsyncCall({
    url: `${BACKEND_URL}health-check`,
    method: 'GET',
  });

export const HealthCheckService = {
  healthCheck: () => healthCheck(),
};
